module.exports = __webpack_public_path__ + "static/media/TrashJoes-hero.d14ff27c.jpg";